<script>
export default{
    UserCode: '', /*用户编码*/
    UserId: '' ,/*用户唯一ID用于与ESS以及Workflow关联*/
    CustomerId: '',
    FullMenu: [],
    LeftMenu: [],
    pageSize:15,
    DateFormat:  '',

    logout:function() {
    },
    get:function(fieldName) {

        var me = this;
        if(this.hasOwnProperty(fieldName))
            return me[fieldName];
        else
            return null;

    },
    set:function(fieldName,value)
    {
        var me = this;
        if(this.hasOwnProperty(fieldName))
            me[fieldName] = value;
        
    },
    isNull2:function(val,defaultVal)
    {
        if(val==null){
            return defaultVal;
        }
        else
        {
            return val
        }
    },

    loadFromStorage:function()  {
        this.set("UserId", window.localStorage.getItem("UserId"));
        this.set("UserCode", window.localStorage.getItem("UserCode"));
        this.set("DateFormat", window.localStorage.getItem("DateFormat"));
        this.set("CustomerId", window.localStorage.getItem("CustomerId"));
    },
    saveToStorage:function()  {

        window.localStorage.setItem("UserCode", this.get("UserCode"));
        window.localStorage.setItem("UserId", this.get("UserId"));
        window.localStorage.setItem("DateFormat", this.get("DateFormat"));
        window.localStorage.setItem("CustomerId", this.get("CustomerId"));
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Model/User.vue